import { PRINT_TICKET, UPPER_SCREEN } from '../actionTypes';

export const PrintTicket = (payload) => ({
  type: PRINT_TICKET,
  payload,
});

export const UpperScreen = (payload) => ({
  type: UPPER_SCREEN,
  payload,
});
